import styled from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import React from 'react';
import { I as InputGeneric } from './index.styled7.js';
import { I as InputText } from './index.styled2.js';
import { I as InputNumber } from './index.styled3.js';
import { I as InputTags } from './index.styled4.js';
import { I as InputSearch } from './index.styled5.js';
import { I as InputPassword } from './index.styled6.js';
import { T as TYPES, C as COMMON_PROP_TYPES, a as COMMON_DEFAULT_PROPS } from './index.styled8.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Input$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var type = _ref.type,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  if (type === TYPES.TEXT) {
    return /*#__PURE__*/jsx(InputText, _objectSpread({
      ref: ref
    }, otherProps));
  }

  if (type === TYPES.NUMBER) {
    return /*#__PURE__*/jsx(InputNumber, _objectSpread({
      ref: ref
    }, otherProps));
  }

  if (type === TYPES.TAGS) {
    return /*#__PURE__*/jsx(InputTags, _objectSpread({
      ref: ref
    }, otherProps));
  }

  if (type === TYPES.SEARCH) {
    return /*#__PURE__*/jsx(InputSearch, _objectSpread({
      ref: ref
    }, otherProps));
  }

  if (type === TYPES.PASSWORD) {
    return /*#__PURE__*/jsx(InputPassword, _objectSpread({
      ref: ref
    }, otherProps));
  }

  return /*#__PURE__*/jsx(InputGeneric, _objectSpread({
    type: type,
    ref: ref
  }, otherProps));
});
Input$1.COMPONENT_ID = 'Gearz.Input';
Input$1.displayName = Input$1.COMPONENT_ID;
Input$1.Text = InputText;
Input$1.Number = InputNumber;
Input$1.Tags = InputTags;
Input$1.Search = InputSearch;
Input$1.Password = InputPassword;
Input$1.propTypes = _objectSpread({}, COMMON_PROP_TYPES);
Input$1.defaultProps = _objectSpread({}, COMMON_DEFAULT_PROPS);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Input = styled(Input$1).withConfig({
  componentId: "gz-input-1679042055220__sc-76njmx-0"
})(["", ""], function (props) {
  return getThemeByProps({
    componentId: Input$1.COMPONENT_ID,
    props: props
  });
});
Input.displayName = Input$1.displayName;
Input.propTypes = Input$1.propTypes;
Input.defaultProps = Input$1.defaultProps;

export { Input as I };
